import type React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '..'

export type TabsProps = React.ComponentProps<typeof Tabs>

const Tabs = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid var(--gray200);
  margin-bottom: -1px;
  data-testid: "tabs"
`

export type TabProps = React.ComponentProps<typeof Tab>

const activeStyles = css`
  border-color: var(--brand-primary);
  border-bottom-width: 3px;
  box-shadow: none;
  color: var(--brand-primary);
`

export const Tab = styled.div<{
  active?: boolean
  variant?: 'default' | 'primary'
  disabled?: boolean
}>`
  padding: 23px 30px 10px;
  border: 0;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-color: transparent;
  border-radius: 0;
  transition: background-color 0.1s ease, border-bottom-color 0.1s ease;
  background-color: transparent;
  text-align: center;
  color: var(--gray600);

  ${(props) =>
    props.variant === 'primary' &&
    css`
      left: 4px;
      top: 4px;
      height: 1rem;
      width: 1rem;
    `}

  ${(props) =>
    props.active &&
    `
    ${activeStyles}

    &:not(:disabled) {
      border-color: var(--brand-primary);
    }
  `}

  ${(props) =>
    props.disabled
      ? `
      pointer-events: none;
      background: var(--gray200);
  `
      : `
    background-color: transparent;

    &:hover > div {
      color: var(--brand-primary);
    }

    &:hover,
    &:active,
    &:focus,
    &:focus-within {
      ${activeStyles}
      background-color: transparent;
    }`}

`

export default Tabs
